import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { AppButton } from "components/common/buttons";

export default function SectionCard({ title, subtitle, action, children, sx }) {
  return (
    <Paper className="subcontract-section-card" elevation={0} sx={sx}>
      {(title || action) && (
        <Box className="subcontract-section-card__header">
          <Box>
            {title && <Typography variant="subtitle1" fontWeight={700}>{title}</Typography>}
            {subtitle && <Typography variant="body2" color="text.secondary">{subtitle}</Typography>}
          </Box>
          {typeof action === "string" ? <AppButton size="small">{action}</AppButton> : action}
        </Box>
      )}
      <Box className="subcontract-section-card__body">{children}</Box>
    </Paper>
  );
}
